<input
  class="form-control"
  type="text"
  mask-number
  [id]="id"
  [name]="name"
  [mask]="maskModel"
  [placeholder]="placeholder"
  dateMessage="Data inválida!"
  [ngModel]="value"
  (ngModelChange)="writeValue($event)"
  inputmode="numeric"
  pattern="[0-9]*"
  appShowErrorMessages>
